// extracted by mini-css-extract-plugin
export default {"dialog":"style--dialog--7e5758","primaryButton":"style--primaryButton--a8c742"};